﻿
var paging = require("././comp/paging");//page handle
var lang = require("././comp/lang");// lang handle
var header = require("./header");// header handler 
var footer = require("./footer");// header handler 
 

myApp.controller("appCtrl", ['$scope', '$http', '$timeout', function ($scope, $http, $timeout) {
    $scope.projectType = "calcalist";
    $scope.meta = {
        description: 'Yit מתמחה במתן שירותים דיגיטליים מתקדמים בראייה של 360 מעלות, במטרה להבטיח את המענה המדויק עבור הפרויקט שלכם. הצוות שלנו כולל את הטובים בתחומם – כל אחד ואחת מהם ישמחו להעמיד לרשותכם את המומחיות, היצירתיות והניסיון שלהם'
    }

    //invoke splitted codes
    header($scope);//invoke header
    lang($scope);//invoke langauge
    paging($scope);// invoke pages
    footer($scope);// invoke pages


    $scope.page = "home";
    $scope.pageTitle = "";
    $scope.strings = "";
    $scope.pageClass = "";
    $scope.address = "";
    $scope.isProjectPage = false;
    $scope.currentPage = 'views/pages/' + $scope.page + '.html';
    // custom functions
    $scope.getStrings = function () {

        try {
            $http.get(AppSettings.baseUrl + "/shared/getstrings")
            .then(function (data) {
             var xml = $.parseXML(data.data);
             $scope.address = $(xml).find("address").find($scope.lang).text().trim();
             $scope.strings = $(xml);
         });

        } catch (e) {
            console.log(e);
        }
    }



    //
    $scope.WaitForStrings = function (func) {
        $scope.$watch('strings', function () {
            if (this.strings != "") {
                try {
                    func();
                } catch (e) {
                    console.warn(e);
                }
            }
        }.bind($scope));
    }

    $scope.getStrings();
}]);
//pages
require("../pages/home");
require("../pages/about");
require("../pages/expertise");
require("../pages/allprojects");
require("../pages/joinus");
require("../pages/contact");
require("../form");

require("./projects");
function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

window.setCover = function () {
    try {
        var imgback = $(".col.unfixed").css("background-image").split("url")[1].split("/");
        imgback = imgback[imgback.length - 1];
        imgback = imgback.split(")")[0];
        imgback = imgback.split(".")[0];
        $(".col.unfixed").attr("data-img", imgback);
        coverFit();
        $(window).on("resize", coverFit);
    } catch (e) {

    }
}
window.coverFit = function () {

    var page = $(".col.unfixed").css("background-image").split("/images")[1].split("/")[1];
    if (innerWidth <= 800) {
        if (!$("body").hasClass("yit-home-page")) {
            $(".col.unfixed").css("background-image", "url(" + AppSettings.baseUrl+"/" + page + "/cover_m.jpg')")
        }
    }
    else {
        $(".col.unfixed").css("background-image", "url(" + AppSettings.baseUrl+"/images/" + page + "/" + $(".col.unfixed").attr("data-img") + ".jpg')")
    }
}

if (!$("body").hasClass("yit-home-page") && !$("body").hasClass("all-project")) {
    if ($("body").hasClass("ngproject")) {

    }
    else {
        setCover();
    }

}


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/app.js
// module id = 8
// module chunks = 0